module.exports = __webpack_public_path__ + "img/working.ca3174cf.png";